import { GET_LANGUAGES, API_RESPONSE_SUCCESS, API_RESPONSE_ERROR } from "./actionType";

export const getLanguages = () => ({
    type: GET_LANGUAGES
});

export const languageApiResponseSuccess = (actionType, data) => ({
    type: API_RESPONSE_SUCCESS,
    payload: { actionType, data }
});

export const languageApiResponseError = (actionType, error) => ({
    type: API_RESPONSE_ERROR,
    payload: { actionType, error }
}); 